module.exports = __webpack_public_path__ + "img/credit-card-minus.5b413d3d.svg";